import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as smartConnectServices from "../../../services/smartConnect/smartConnect.services.js";

export const smartConnectSummary = createAsyncThunk(
    "smartConnect/getSummary",
    async (_, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.fetchSummary();
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed To Fetch Smart Connect Summary."
                );
            }

            return res?.data || {};
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Error while fetching summary"
            );
        }
    }
);


const initialState = {
    summary: {},
    loading: false,
    error: null,
};

const smartConnectSummarySlice = createSlice({
    name: "smartConnectSummary",
    initialState,
    reducers: {
        resetUploadResult: (state) => {
            state.uploadResult = null;
        },
    },
    extraReducers: (builder) => {
        builder

            // FETCH SUMMARY 
            .addCase(smartConnectSummary.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(smartConnectSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.summary = action.payload;
            })
            .addCase(smartConnectSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export const smartConnectSummaryReducer = smartConnectSummarySlice.reducer;
